<template>

  <div>

    <!-- banner -->
    <BannerBlog></BannerBlog>


    <!-- post blog -->
    <PostBlogAll></PostBlogAll>

  </div>  

</template>


<script>
  
  import BannerBlog from './../components/BannerBlog'
  import PostBlogAll from './../components/PostBlogAll'

  export default
  {
    components: {
      BannerBlog,
      PostBlogAll
    }
  }

</script>